import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { getUserOrganizationQueryKey, getUserOrganizationResponse, } from '#pplx/frontend/user-info/orgInfoQueries.js';
import { useMemo } from 'react';
const DEFAULT_USER_ORG_INFO = {};
export const useUserOrgInfo = ({ enabled, reason, }) => {
    const query = useQuery({
        enabled: enabled ?? true,
        queryKey: getUserOrganizationQueryKey(),
        queryFn: () => getUserOrganizationResponse({ reason }),
        // Share the full response with policy consumers without persisting it.
        meta: { skipPersistence: true },
        select: (data) => ({
            orgServiceType: data.organization?.org_service_type ?? undefined,
        }),
    });
    const data = query.data ?? DEFAULT_USER_ORG_INFO;
    return useMemo(() => ({
        query,
        ...data,
    }), [query, data]);
};
//# sourceMappingURL=useUserOrgInfo.js.map